import {Component, Input, OnChanges} from '@angular/core';
import {TranslocoPipe} from "@jsverse/transloco";
import {PortfolioPhoto} from '../../../../core/entities/portfolio/portfolio-photo.entity';
import {PortfolioService} from '../../../services/portfolio/portfolio.service';
import {CarouselComponent} from '../../../../core/components/carousel/carousel.component';
import {AppImageComponent} from '../../../../core/components/image/image';

@Component({
  selector: 'app-photographer-portfolio',
  imports: [
    TranslocoPipe,
    CarouselComponent,
    AppImageComponent
  ],
  templateUrl: './photographer-portfolio.html',
  standalone: true,
  styleUrl: './photographer-portfolio.scss'
})
export class PhotographerPortfolio {
  @Input() portfolio: PortfolioPhoto[]|null = null;

  public carouselIndex = 0;
  public carouselOpen = false;

  openCarousel(idx: number) {
    this.carouselIndex = idx;
    this.carouselOpen = true;
  }

  public closeCarousel() {
    this.carouselOpen = false;
  }
}
